"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** The paragraphs are used for regular content text */
function Paragraph(_ref) {
  var type = _ref.type,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["type", "children", "className"]);

  return /*#__PURE__*/_react.default.createElement("p", _extends({}, props, {
    className: (0, _utils.getClassNames)(className, "paragraph_".concat(type))
  }), children);
}

Paragraph.propTypes = {
  /** The type of text: primary, secondary, title */
  type: _propTypes.default.oneOf(_constants.PARAGRAPH_TYPES),

  /** @ignore */
  children: _propTypes.default.node,

  /** @ignore */
  className: _propTypes.default.string
};
Paragraph.defaultProps = {
  type: _constants.PARAGRAPH_TYPE_PRIMARY,
  children: null,
  className: null
};
var _default = Paragraph;
exports.default = _default;